import { Howl } from "howler";
import { convertCreditsFromServerToClient } from "../../../../common/datastructures/Credits";
// import { getParameterByName } from "../../common/getParameters";
// import { createMovieClip } from "../../../../common/functions/Functions_General";

import { GameData } from "../../gamestate/gameData";
// import { BonusGameInfoPortraitUI } from "./bonusGamePortraitUI";
import { BonusSpinMessageWindow } from "./BonusSpinMessageWindow";
import DeviceChecker from "../../../../common/functions/helper.ts/DeviceChecker";

export class BonusGameInfoUI {
  // private
  private landscapeContainer: PIXI.Container;
  // private fireOverlay:PIXI.extras.AnimatedSprite;
  private plusSpinTween: PIXI.tween.Tween;
  private gameMessageDisplay: BonusSpinMessageWindow; //--USED
  // private smallOrbs:			Array<PIXI.Sprite>;//Small orbs around
  private spinsLeftDisplay: PIXI.Text;
  private fadeIn: PIXI.tween.Tween;
  private fadeOut: PIXI.tween.Tween;
  private bgFrame: PIXI.Sprite;
  // private orbBig:				PIXI.extras.AnimatedSprite;
  private parent: PIXI.Container;
  private textStyle: PIXI.TextStyle;
  private smalltextStyle: PIXI.TextStyle;
  // private textStyleB:			PIXI.TextStyle;
  private bigtextStyle: PIXI.TextStyle;
  private plusSpin: PIXI.Text;
  private totalWin: PIXI.Text;
  private spinsLeft: PIXI.Text;
  private totalWinDisplay: PIXI.Text;
  private multiplyValue: Array<number>;
  // private multiplierNumbs:	Array<string>;
  // private smallOrbsTextA:		Array<PIXI.Text>;
  private smallOrbsTextB: Array<PIXI.Text>;
  private activeGameData: GameData;
  private fx: PIXI.Sprite;
  private fxTween: PIXI.tween.Tween;
  private extra_Sound: Howl;
  private isVisible: boolean;
  // private portraitUI:BonusGameInfoPortraitUI;

  constructor(
    parent: PIXI.Container,
    size: Array<number>,
    activeGameData: GameData
  ) {
    this.isVisible = false;
    this.activeGameData = activeGameData;
    this.landscapeContainer = new PIXI.Container();
    this.gameMessageDisplay = new BonusSpinMessageWindow(
      parent,
      size,
      activeGameData
    );
    this.bgFrame = new PIXI.Sprite(PIXI.Texture.fromImage("bgDayGradient.png"));
    // this.orbBig=createMovieClip("fireOrbAnim",0,53);
    // this.parent=parent;

    this.parent = new PIXI.Container();
    parent.addChild(this.parent);
    this.parent.addChild(this.landscapeContainer);
    this.landscapeContainer.addChild(this.bgFrame);

    this.fx = new PIXI.Sprite(PIXI.Texture.fromFrame("wos_lightSwipe.png"));
    this.fx.anchor.set(0.5);
    this.fx.y = -150;
    this.bgFrame.addChild(this.fx);
    this.fxTween = PIXI.tweenManager.createTween(this.fx);
    this.fxTween
      .from({ scale: { x: 3.5, y: 3.5 }, alpha: 0 })
      .to({ scale: { x: 1, y: 1 }, alpha: 1 });
    this.fxTween.time = 1500; //300 ease in default
    this.fxTween.easing = PIXI.tween.Easing.linear();
    this.fxTween.loop = false;
    // this.fxTween.start();
    this.fx.alpha = 0;

    // this.bgFrame.addChild(this.orbBig);
    this.textStyle = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 40,
      fill: "#ffffff",
      fontWeight: "bold",
      lineHeight: 80,
      align: "center",

      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });

    // this.textStyleB=new PIXI.TextStyle({ fontFamily: activeGameData.gameTextStyle.gameFont,
    //     fontSize: 40,
    //     fill: '#ffffff' ,
    //     fontWeight:"bold",
    //     lineHeight : 80,
    //     align:'right',

    //     dropShadow: true,
    //     dropShadowColor: '#000000',
    //     dropShadowBlur: 10,
    //     dropShadowAngle: Math.PI / 6,
    //     dropShadowDistance: 0,
    // });
    this.smalltextStyle = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 30,
      fill: "#ffffff",
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",

      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      wordWrap: true,
      wordWrapWidth: 250,
    });
    this.bigtextStyle = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 100,
      fill: "#ffffff",
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",

      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });
    this.plusSpin = new PIXI.Text("+1", this.bigtextStyle);
    this.plusSpin.anchor.set(0.5);
    this.plusSpin.alpha = 1;
    this.plusSpinTween = PIXI.tweenManager.createTween(this.plusSpin);

    // this.bgFrame.addChild(this.plusSpin);
    this.totalWin = new PIXI.Text(
      this.activeGameData.gameTextGeneral.totalWin,
      this.smalltextStyle
    );
    this.spinsLeft = new PIXI.Text(
      this.activeGameData.gameText.firespinsleft,
      this.smalltextStyle
    );

    this.totalWinDisplay = new PIXI.Text("00.00", this.textStyle);
    this.spinsLeftDisplay = new PIXI.Text("0", this.bigtextStyle);

    this.bgFrame.addChild(this.totalWin);
    this.bgFrame.addChild(this.spinsLeft);

    this.bgFrame.addChild(this.totalWinDisplay);
    this.bgFrame.addChild(this.spinsLeftDisplay);
    this.multiplyValue = [0, 0, 0];
    // this.multiplierNumbs=["0","0","0"];

    // let pT=this.activeGameData.gamePayTableValues;
    // this.multiplyValue=null//pT.getMultipler(0,false);
    // let mt=null//pT.getComLength(0,false);
    // for (let i = 0; i < mt.length; i++) {
    //   this.multiplierNumbs[i]=(mt[i]+'x');

    // }

    // console.log(this.multiplierNumbs, this.multiplyValue)

    // this.orbValueList=[(this.activeGameData.betSelected.getDisplayValue()*this.multiplyValue[0]).toFixed(2),(this.activeGameData.betSelected.getDisplayValue()*this.multiplyValue[1]).toFixed(2),(this.activeGameData.betSelected.getDisplayValue()*this.multiplyValue[2]).toFixed(2)];
    // this.smallOrbs=[];//Small orbs around
    // this.smallOrbsTextA=[];
    this.smallOrbsTextB = [];

    this.fadeIn = PIXI.tweenManager.createTween(this.landscapeContainer);
    this.fadeOut = PIXI.tweenManager.createTween(this.landscapeContainer);

    // this.fireOverlay=createMovieClip("messageFrameFire",0,8);
    // this.fireOverlay.anchor.set(.5);
    // // this.fireOverlay.scale.set(.82,.6)
    // this.fireOverlay.width=this.bgFrame.height+80;
    // this.fireOverlay.height=this.bgFrame.width+100;
    // this.fireOverlay.rotation=Math.PI/2;
    // this.fireOverlay.position.set(0,0)

    // this.fireOverlay.blendMode=PIXI.BLEND_MODES.SCREEN;
    // this.fireOverlay.alpha=0;
    // this.fireOverlay.stop();
    // this.bgFrame.addChild(this.fireOverlay);

    this.setup();

    this.extra_Sound = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/337049_extraSpin.m4a?" +
          "version=" +
          activeGameData.gameVersion,
      ],

      sprite: {
        // music: [0, 20869,true],
        extra: [0, 1150, false],
      },
    });

    this.activeGameData.soundList.push(this.extra_Sound);

    //---create portrait version of bonusgame UI
    // this.portraitUI= new BonusGameInfoPortraitUI(this.activeGameData);
    // this.portraitUI;

    this.createListener();
  }

  private createListener = (): void => {
    window.addEventListener("resize", this.checkDisplayModeForMobile, false);
    window.addEventListener(
      "orientationchange",
      this.checkDisplayModeForMobile,
      false
    );
    this.checkDisplayModeForMobile();
  };
  // private setFireOn=(bool:boolean):void=>
  // {
  //     if(bool)
  //     {
  //         this.fireOverlay.alpha=1;
  //         this.fireOverlay.play();
  //     }
  //     else{
  //         this.fireOverlay.alpha=0;
  //         this.fireOverlay.stop();
  //     }
  // }
  private setup = (): void => {
    this.bgFrame.anchor.set(0.5);
    this.bgFrame.x = this.bgFrame.width - 45; //-105;
    this.bgFrame.y = this.parent.height / 2 - 170 - 20;
    // this.orbBig.x=0;
    // this.orbBig.y=-160+2;
    // this.orbBig.anchor.set(.5);
    // this.orbBig.play();
    // this.orbBig.scale.set(.9);

    this.totalWin.anchor.set(0.5);
    this.spinsLeft.anchor.set(0.5);

    this.totalWin.y = 225;
    // this.spinsLeft.y=this.orbBig.y+50

    this.totalWinDisplay.anchor.set(0.5);
    this.totalWinDisplay.y = 300;

    this.spinsLeftDisplay.anchor.set(0.5);
    // this.spinsLeftDisplay.y= this.orbBig.y-25
    this.spinsLeftDisplay.scale.set(0.8);

    //  for (var i = 0; i < 3; i++) {
    //  	this.smallOrbs[i]= new PIXI.Sprite(PIXI.Texture.fromImage('fireOrbAnim_small.png'));
    //  	this.bgFrame.addChild(this.smallOrbs[i]);
    //  	this.smallOrbs[i].anchor.set(.5);
    //  	this.smallOrbs[i].y=-30+i*80+30;
    //  	this.smallOrbs[i].x=-100;
    //  	this.smallOrbs[i].alpha=.5

    //  	this.smallOrbsTextA[i]=new  PIXI.Text(  this.multiplierNumbs[i], this.textStyle);  //3x 4x 5x
    //  	this.smallOrbsTextA[i].anchor.set(.5)
    //  	this.smallOrbsTextA[i].position.set(0,+this.smallOrbsTextA[i].height/4)
    //  	this.smallOrbs[i].addChild(this.smallOrbsTextA[i])

    // 	//  this.smallOrbsTextB[i]=new  PIXI.Text(  (this.activeGameData.betSelected.getDisplayValue())*this.multiplyValue[i]).toFixed(2), this.textStyleB);  //3x 4x 5x

    //  	this.smallOrbsTextB[i]=new  PIXI.Text(  convertCreditsFromServerToClient((this.activeGameData.betSelected.value*this.multiplyValue[i])).toFixed(2), this.textStyleB);  //3x 4x 5x
    //  	// this.smallOrbsTextB[i].anchor.set(.5)

    //  	this.smallOrbs[i].addChild(this.smallOrbsTextB[i]);

    //  }

    // this.setNewOrbMultiplierValue()

    this.landscapeContainer.alpha = 0; //----default 0
    this.fadeIn.from({ alpha: 0, x: 100 }).to({ alpha: 1, x: 0 });
    this.fadeIn.time = 500;
    this.fadeIn.easing = PIXI.tween.Easing.outBack();
    // this.fadeIn.reset();

    this.fadeOut.from({ alpha: 1, x: 0 }).to({ alpha: 0, x: 100 });
    this.fadeOut.time = 0;
    this.fadeOut.easing = PIXI.tween.Easing.outBack();
    // this.fadeOut.reset();

    // this.fadeIn.on('start',function(self:BonusGameInfoUI){

    //     self.setFireOn(false)
    // }.bind(this.fadeIn,this))

    // this.fadeOut.on('start',function(self:BonusGameInfoUI){

    //     self.setFireOn(false)
    // }.bind(this.fadeOut,this))

    this.plusSpinTween
      .from({ alpha: 1, y: -300, scale: { x: 1, y: 1 } })
      .to({ alpha: 0, y: -200, scale: { x: 0.5, y: 0.5 } });
    this.plusSpinTween.time = 2000;
    this.plusSpinTween.easing = PIXI.tween.Easing.outExpo();
    // this.plusSpinTween.loop=true;
    if (this.activeGameData.isMobile) {
      this.landscapeContainer.scale.set(1);
      this.bgFrame.x = this.bgFrame.width - 45 - 110; //-105;
      this.bgFrame.y = this.bgFrame.height / 2 + 200;
    } else {
      this.landscapeContainer.scale.set(1);
      this.bgFrame.x = this.bgFrame.width - 45 - 50; //-105;
      this.bgFrame.y = this.bgFrame.height / 2 + 240;
    }
  };

  public setNewOrbMultiplierValue = (): void => {
    for (var i = 0; i < 3; i++) {
      this.smallOrbsTextB[i].text = (
        convertCreditsFromServerToClient(
          this.activeGameData.betSelected.value * this.multiplyValue[i]
        ) /
        this.activeGameData.loginResponse.gameSettings.payTable
          .baseGameWinLineCount
      ).toFixed(2);
      this.smallOrbsTextB[i].position.set(
        this.bgFrame.width - this.smallOrbsTextB[i].width - 70,
        -20
      );
    }
  };

  public updateTotalWinDisplay = (): void => {
    //update with new bet value the multiplier and also update the total win;

    this.totalWinDisplay.text = convertCreditsFromServerToClient(
      this.activeGameData.GameContext().gameRoundBalance.credits.amount
    ).toFixed(2);
    // console.log(this.totalWinDisplay.text)
    // this.portraitUI.setWinTotal(this.totalWinDisplay.text);
  };

  public animateExtraSpin() {
    this.fxTween.reset();
    this.fxTween.start();
    this.plusSpinTween.reset();
    this.plusSpinTween.start();
    this.extra_Sound.play("extra");
    // this.spinsLeftDisplay.text = this.activeGameData.betResponse.gameContext.gameRoundBalance.bonusSpins;

    this.setSpinLeftText(
      this.activeGameData.GameContext().gameRoundBalance.bonusSpins.toString()
    );
    // }
  }

  // substractSpinsLeft()
  // {

  // }

  // update()
  // {
  //     activeGameData.bonusGameInfos.spinsLeftDisplay.text = ((activeGameData.betResponse.gameContext)).gameRoundBalance.bonusSpins;
  // }

  public getIsVisibile() {
    let visible = this.landscapeContainer.alpha ? true : false;
    return visible;
  }

  private setTweenReset() {
    this.fadeIn.reset();
    this.fadeIn.stop();
    this.fadeOut.reset();
    this.fadeOut.start();
  }

  // private getFadeIN()
  // {
  //     return this.fadeIn;
  // }

  public setSpinLeftText(newText: string) {
    this.spinsLeftDisplay.text = newText;
    // this.portraitUI.setSpinCount(newText);
  }

  // public setOrbAlpha(index:number,newAlpha:number)
  // {
  //     // this.smallOrbs[index].alpha=newAlpha;
  // }
  public getMessageBox = (): BonusSpinMessageWindow => {
    return this.gameMessageDisplay;
  };

  public getSpinLeftText = (): string => {
    return this.spinsLeftDisplay.text;
  };

  //--

  public setVisible = (bool: boolean): void => {
    if (bool) {
      this.fadeIn.start();
      this.isVisible = true;
      this.checkDisplayModeForMobile();
    } else {
      // this.fadeOut.start();
      this.setTweenReset();
      this.isVisible = false;
      this.checkDisplayModeForMobile();
    }
  };

  private checkDisplayModeForMobile = (): void => {
    //-check window orientation mode
    // console.log('CHECK MODE');

    let screenRatio = window.innerHeight / window.innerWidth;
    let orientationPortrait = window.matchMedia("(orientation: portrait)")
      .matches;
    let verticalMode = false;
    if (
      orientationPortrait &&
      screenRatio >= this.activeGameData.minRatioForPortraitPlay
    ) {
      verticalMode = true;
    }

    if (
      this.isVisible &&
      this.activeGameData.isMobile &&
      this.activeGameData.playOnPortrait
    ) {
      //
      // console.log('CHECK MODE',verticalMode);
      if (verticalMode) {
        // this.portraitUI.setVisible(true);
        this.parent.alpha = 0;
      } else {
        // this.portraitUI.setVisible(false);
        this.parent.alpha = 1;
      }
    }

    // if(this.isVisible==false)
    // {
    //     this.portraitUI.setVisible(false);
    // }
  };
}
